import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, ref, Ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import { useGetNavigationTreeQuery } from '@/entities/app/hooks';

import { BreadcrumbLink } from '@/core/components/navigation/Breadcrumb/breadcrumb.shared';
import { NavigationTreeItem } from '@/entities/app/types';

import { NkBreadcrumb } from '@/core/components';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardNavigationInspectionBreadcrumb',
  setup(__props) {

const route = useRoute();
const { t } = useI18n();

const navigationTreeQueryData: Ref = computed(() => {
  if (route.name === 'visionair-inspection') {
    return {
      slug: 'inspection',
      id: route.params.inspection,
    };
  }

  if (route.name === 'visionair-inspection-group') {
    return {
      slug: 'inspection-group',
      id: route.params.inspectionGroup,
    };
  }

  if (route.name === 'visionair-device-group') {
    return {
      slug: 'device-group',
      id: route.params.deviceGroup,
    };
  }

  if (route.name === 'visionair-device') {
    return {
      slug: 'device',
      id: route.params.device,
    };
  }

  return { slug: '', id: null };
});

const hasNavigationTree = computed(() =>
  (navigationTreeQueryData.value.slug &&
    navigationTreeQueryData.value.id &&
    Object.keys(route?.params || {}).some((key: string) => ['deviceGroup', 'device', 'inspectionGroup', 'inspection'].includes(key))) || false);

const placeholderData = ref();

const { data: navigationTreeItems, remove } = useGetNavigationTreeQuery(navigationTreeQueryData, {
  enabled: hasNavigationTree,
  placeholderData,
  onSuccess: (data) => {
    placeholderData.value = data;
  },
});

const TreeItemKeyData = ['device', 'deviceGroup', 'inspectiongroup'] as const;
const getTreeItemRouteData = (type: typeof TreeItemKeyData[number]) => {
  const items = {
    device: {
      name: 'visionair-device',
      paramsName: 'device',
    },
    devicegroup: {
      name: 'visionair-device-group',
      paramsName: 'deviceGroup',
    },
    inspectiongroup: {
      name: 'visionair-inspection-group',
      paramsName: 'inspectionGroup',
    },
  };

  return items[type];
};

const generateLink = (item: NavigationTreeItem): BreadcrumbLink => {
  const { name, paramsName } = getTreeItemRouteData(item.type);
  return {
    name: item.name,
    to: paramsName === 'inspectionGroup' ? null : {
      name,
      params: {
        [paramsName]: item.id,
      },
    },
    sublinks: (item.siblings?.length ? item.siblings.map(o => generateLink(o)) : []),
  };
};

const navigationTree = computed(() => navigationTreeItems.value?.map(o => generateLink(o)) || []);

const links = computed(() => [
  {
    name: t('breadcrumb.dashboard'),
    to: {
      name: 'visionair-dashboard',
    },
  },
  ...navigationTree.value,
]);

onMounted(() => {
  placeholderData.value = [];
});

watch(() => navigationTree.value, (item) => {
  const firstDeviceGroup = item.find(o => o?.to?.name === 'visionair-device-group');

  if (firstDeviceGroup && firstDeviceGroup.name) {
    document.title = `${ firstDeviceGroup.name } - ${ process.env.VUE_APP_TITLE }`;
  } else {
    document.title = process.env.VUE_APP_TITLE;
  }
});

watch(route, () => {
  if (route.name === 'visionair-dashboard') {
    placeholderData.value = [];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkBreadcrumb), { links: _unref(links) }, null, 8, ["links"]))
}
}

})